import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// ✅ FIX: Use a default import for the service object
import courseService from '../../services/courseService';
import type { ICourse } from '../../types/course';
import Loader from '../../components/common/Loader';
import { showToast } from '../../utils/showToast';
import { BookOpen, DollarSign, Clock } from 'lucide-react';

const Courses: React.FC = () => {
  const [courses, setCourses] = useState<ICourse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  // ✅ FIX: Correctly destructure setError to update the error state
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCourses = async () => {
      setIsLoading(true);
      try {
        // ✅ FIX: Call the correct function from the service object
        const data = await courseService.getAllPublishedCourses();
        setCourses(data);
      } catch (err: any) {
        setError(err.message); // Use setError
        showToast(err.message, { type: 'error' });
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10">
        <p className="text-red-600 font-medium">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="py-10 px-4">
      <div className="max-w-7xl mx-auto text-center mb-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Courses</h1>
        <p className="text-lg text-gray-600">
          Explore our comprehensive range of programs.
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {courses.length === 0 ? (
          <p className="text-center text-gray-500 col-span-full">No courses published yet.</p>
        ) : (
          courses.map((course) => (
            // ✅ FIX: Link now uses the slug-based URL pattern
            <Link key={course._id} to={`/courses/slug/${course.slug}`} className="block group">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden group-hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
                {course.image && (
                  <div className="overflow-hidden">
                    <img src={course.image} alt={course.title} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300" />
                  </div>
                )}
                <div className="p-6 space-y-3 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{course.title}</h3>
                    <p className="text-sm text-gray-700">{course.description.substring(0, 100)}...</p>
                  </div>
                  <div className="mt-4 space-y-2 text-sm text-gray-600">
                    <div className="flex items-center">
                      <BookOpen className="w-4 h-4 mr-2 text-blue-500" />
                      <span>Instructor: {course.instructorName}</span>
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-2 text-indigo-500" />
                      <span>Duration: {course.duration}</span>
                    </div>
                    <div className="flex items-center">
                      <DollarSign className="w-4 h-4 mr-2 text-green-500" />
                      <span>Price: {course.price ? `₹${course.price.toLocaleString()}` : 'Contact for price'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default Courses;